<template>
    <div class="fee-cards ml-4">
        <v-row>
            <v-col cols="4" md="4">
                <v-btn height="100" @click="emitPaymentStatusFilter('Paid')" block tile color="#4CD137" class="white--text fee-card">
                    <v-row>
                        <v-col cols="12" class="py-0 px-0">
                            <h1 class="mb-1">{{ counts.paid }}</h1>
                        </v-col>
                        <v-col cols="12" class="py-0 px-0">
                            <p class="my-0">Paid</p>
                        </v-col>
                    </v-row>
                </v-btn>
            </v-col>
            <v-col cols="4" md="4">
                <v-btn height="100" @click="emitPaymentStatusFilter('Due')" block tile color="#FF7700" class="white--text fee-card">
                    <v-row>
                        <v-col cols="12" class="py-0 px-0">
                            <h1 class="mb-1">{{ counts.due }}</h1>
                        </v-col>
                        <v-col cols="12" class="py-0 px-0">
                            <p class="my-0">Due</p>
                        </v-col>
                    </v-row>
                </v-btn>
            </v-col>
            <v-col cols="4" md="4">
                <v-btn height="100" @click="emitPaymentStatusFilter('Overdue')" block tile color="#FF0000" class="white--text fee-card">
                    <v-row>
                        <v-col cols="12" class="py-0 px-0">
                            <h1 class="mb-1">{{ counts.overdue }}</h1>
                        </v-col>
                        <v-col cols="12" class="py-0 px-0">
                            <p class="my-0">Overdue</p>
                        </v-col>
                    </v-row>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'FeeCards',
    props: ['counts'],
    methods: {
        emitPaymentStatusFilter(status){
            this.$emit('payment_status',status);
        }
    }
}
</script>

<style scoped>
.fee-card{
    border-radius: 10px;
}
</style>